export interface IPasswordManagerState {
    passwordList: IPasswordResponse[];
    selectedPasswordRecordExtId: string;
    selectedPasswordDetails: IPasswordDetails;
    loadingPasswordList: boolean;
}

export const REQUEST_PASSWORD_LIST = "REQUEST_PASSWORD_LIST";
export const RECEIVE_PASSWORD_LIST = "RECEIVE_PASSWORD_LIST";
export const SET_RECORD_EXT_ID = "SET_RECORD_EXT_ID";
export const SET_PASSWORD_DETAILS = "SET_PASSWORD_DETAILS";
export const TOGGLE_FAVOURITE = "TOGGLE_FAVOURITE";
export const LOADING_PASSWORD_LIST = "LOADING_PASSWORD_LIST";

export interface IRequestPasswordListAction {
    type: typeof REQUEST_PASSWORD_LIST;
}

export interface IReceivePasswordListAction {
    type: typeof RECEIVE_PASSWORD_LIST;
    passwordList: IPasswordResponse[];
}

export interface ILoadingPasswordListAction {
    type: typeof LOADING_PASSWORD_LIST;
    loadingPasswordList: boolean;
}

export interface ISetPasswordRecordExtId {
    type: typeof SET_RECORD_EXT_ID;
    selectedPasswordRecordExtId: string;
}
export interface IToggleFavourite {
    type: typeof TOGGLE_FAVOURITE;
    selectedPasswordRecordExtId: string;
}

export interface ISetPasswordDetails {
    type: typeof SET_PASSWORD_DETAILS;
    selectedPasswordDetails: IPasswordDetails;
}

export type PasswordManagerTypes =
    | IRequestPasswordListAction
    | ILoadingPasswordListAction
    | IReceivePasswordListAction
    | ISetPasswordRecordExtId
    | ISetPasswordDetails
    | IToggleFavourite;

export interface IPasswordResponse {
    websiteName?: string;
    createdDate?: string;
    updatedDate?: string;
    recordExtId?: string;
    favorite?: number;
    lastPasswordChangedDate?: string;
    strength?: string;
    hasError?: boolean;
}

export interface IPasswordDetails {
    websiteName?: string;
    createdDate?: string;
    recordExtId?: string;
    favorite?: number;
    lastPasswordChangedDate?: string;
    strength?: string;
    hasError?: boolean;
    isSuccess?: boolean;
    notes?: string;
    websiteUrl?: string;
    websitePassword?: string;
    websiteCategory?: any;
    websiteUsername?: string;
    lastUpdateDate?: string;
}
